import { FaArrowUp } from "react-icons/fa";
export default function ScrollTop() {
  const scrollToTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  return (
    <button
      id="scrollTop"
      className="fixed -bottom-10 right-3 shadow-md bg-white transition-all duration-300 ease-in-out flex justify-center m-auto p-3 rounded-lg"
      onClick={() => scrollToTop()}
    >
      <FaArrowUp />
    </button>
  );
}
